export default {
  linkModel: {
    id: 'review_model_title',
    defaultMessage: 'Bought: {link, html}',
  },
}
